import { createSlice } from "@reduxjs/toolkit";

const changePageSlice = createSlice({
  name: "changeItemsPerPage",
  initialState: {
    currentItemsPage: 30,
  },
  reducers: {
    setPageItems: (state, action) => {
      state.currentItemsPage = action.payload;
    },
  },
});

export const { setPageItems } = changePageSlice.actions;
export default changePageSlice.reducer;
